
import React from 'react';

interface ErrorsTabProps {
  stats: any; // Keep the same type as original
}

const ErrorsTab: React.FC<ErrorsTabProps> = ({ stats }) => {
  // Get errors from global error reporting if available
  const globalErrors = window._errorReporting?.getErrors() || [];
  
  return (
    <div>
      {globalErrors.length > 0 ? (
        <div className="space-y-2">
          <div className="text-sm font-medium">Application Errors ({globalErrors.length})</div>
          <div className="max-h-40 overflow-y-auto">
            {globalErrors.map((error, index) => (
              <div key={index} className="mb-2 p-2 text-xs border border-red-200 bg-red-50 dark:bg-red-900/20 rounded">
                <div className="font-medium text-red-600">{error.message}</div>
                <div className="text-[10px] text-gray-500 mt-1">
                  {error.timestamp.toLocaleString()}
                </div>
                {error.stack && (
                  <details className="mt-1">
                    <summary className="cursor-pointer text-gray-600 dark:text-gray-400">Stack trace</summary>
                    <pre className="text-[9px] mt-1 p-1 bg-gray-100 dark:bg-gray-900 overflow-x-auto">
                      {error.stack}
                    </pre>
                  </details>
                )}
              </div>
            ))}
          </div>
          <div>
            <button
              onClick={() => {
                if (window._errorReporting?.clearErrors) {
                  window._errorReporting.clearErrors();
                }
              }}
              className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 rounded"
            >
              Clear Error Log
            </button>
          </div>
        </div>
      ) : (
        <div className="text-gray-500">No application errors reported.</div>
      )}
    </div>
  );
};

export default ErrorsTab;
